import MobilitySkill from './MobilitySkill.js';

export default class TumblingMobilitySkill extends MobilitySkill {
    static entity = 'tumbling-mobility-skills';
}
